<div class="flex space-between gap-4" [ngClass]="snackType">
  <div class="flex items-center">
    <mat-icon [ngClass]="snackType">{{ getIcon }}</mat-icon>
    <span class="ml-2">{{ data.message }}</span>
  </div>

  <mat-icon class="close-icon" (click)="dismiss()">close</mat-icon>
</div>
